import { actionTypes } from 'redux-form';
import {
    constants as dateTimeConstants,
    calculateDuration,
    formatDate,
} from 'js-utils/datetime';
import { adjustEndDateTime } from './utils';

const { ISO_8601_DATE_FORMAT, DEFAULT_TIME_FORMAT } = dateTimeConstants;
const { CHANGE } = actionTypes;

const prefixField = (prefix, fieldName) => `${prefix}${fieldName}`;

const changeReducer = (state, action, prefix = '') => {
    const values = state.values || {};

    const prefixedStartDate = prefixField(prefix, 'startDate');
    const prefixedStartTime = prefixField(prefix, 'startTime');
    const prefixedEndDate = prefixField(prefix, 'endDate');
    const prefixedEndTime = prefixField(prefix, 'endTime');
    const prefixedDuration = prefixField(prefix, 'duration');

    const startDate = formatDate(values[prefixedStartDate]);
    const startTime = values[prefixedStartTime];
    let endDate = formatDate(values[prefixedEndDate]);
    let endTime = values[prefixedEndTime];
    const duration = values[prefixedDuration];

    switch (action.meta.field) {
        case prefixedStartDate: {
            const adjustedMoment = adjustEndDateTime(
                action.payload,
                startTime,
                duration,
            );

            return {
                ...state,

                values: {
                    ...values,
                    [prefixedStartDate]: startDate,
                    [prefixedEndDate]: adjustedMoment.format(
                        ISO_8601_DATE_FORMAT,
                    ),
                },
            };
        }
        case prefixedStartTime: {
            let updatedValues = {
                ...values,
            };

            if (action.payload) {
                const adjustedMoment = adjustEndDateTime(
                    startDate,
                    action.payload,
                    duration,
                );

                updatedValues = {
                    ...updatedValues,
                    [prefixedEndDate]: adjustedMoment.format(
                        ISO_8601_DATE_FORMAT,
                    ),
                    [prefixedEndTime]: adjustedMoment.format(
                        DEFAULT_TIME_FORMAT,
                    ),
                };
            }

            return {
                ...state,

                values: {
                    ...updatedValues,
                },
            };
        }
        case prefixedEndDate:
        case prefixedEndTime: {
            if (action.meta.field === prefixedEndDate) {
                endDate = action.payload;
            } else {
                endTime = action.payload;
            }

            return {
                ...state,

                values: {
                    ...values,
                    [prefixedEndDate]: formatDate(endDate),

                    [prefixedDuration]: calculateDuration({
                        startDate,
                        startTime,
                        endDate,
                        endTime,
                    }),
                },
            };
        }
        default: {
            return state;
        }
    }
};

const ACTION_REDUCER_MAP = {
    [CHANGE]: changeReducer,
};

const dateTimePairReducerPlugin = (prefix = '') => (state, action) => {
    const reducer = ACTION_REDUCER_MAP[action.type];
    let nextState = state || {};

    if (reducer) {
        nextState = reducer(nextState, action, prefix);
    }

    return nextState;
};

const setPlugin = (formName, prefix = '') => ({
    [formName]: dateTimePairReducerPlugin(prefix),
});

export default setPlugin;
